<nav class="nav d-md-flex align-items-center d-none" style="margin-left: 30px; transform: translateY(70px);">
    <a class="nav-link " routerLink="/busqueda-carpetas">
        <h6 class="m-0">Búsqueda de carpetas</h6>
    </a>
    <i class="fa-solid fa-chevron-right chevron"></i>
    <a class="nav-link">
        <h6 class="m-0">Resultado de la búsqueda</h6>
    </a>
</nav>
<app-container header="Resultado de la búsqueda" (clicked)="goToBusqueda()">
    <div class="d-md-flex flex-wrap justify-content-around mt-3">
        <app-cards *ngFor="let result of dataRes.rows | paginator : page_size : pageNumber"
            [result]="result"></app-cards>
    </div>
    <div class="mt-4">
        <app-pagination [totalItems]="total_pages" [itemsPerPage]="page_size"
            (pageChange)="onPageChange($event)">
        </app-pagination>
    </div>
</app-container>